import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import WOStatusComponent from '../WOcomponents/WOStatusComponent';
import WOTagCard from '../WOcomponents/WOTagCard';
import { GridContainer } from '../WorkOrderForVehicle/VehicleDetailCard';

export default function WOStatusFilterComponent({
  orders,
  isVendor,
  history,
  handleStartDone,
  enableOrderTagActions,
  onAddTechnician,
}) {
  const [vehicleOrders, setVehicleOrders] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('All');
  const [availableOrderStatus, setAvailableOrderStatus] = useState([]);
  const [originalVehicleOrders, setOriginalVehicleOrders] = useState([]);

  const setAllOrders = () => {
    const relatedOrders = orders;
    const steps = [...new Set(relatedOrders.map(item => item.step))];

    setVehicleOrders(relatedOrders);
    setOriginalVehicleOrders(relatedOrders);
    setAvailableOrderStatus(steps);
  };

  const filteredOrdersOnStatusChange = () => {
    if (selectedStatus === 'All') {
      setAllOrders();
    } else {
      const filetredVehicleOrders = originalVehicleOrders.filter(
        item => item.step.toLowerCase() === selectedStatus.toLowerCase()
      );
      setVehicleOrders(filetredVehicleOrders);
    }
  };

  useEffect(() => {
    setVehicleOrders(orders);
    setAllOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  useEffect(() => {
    filteredOrdersOnStatusChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus]);

  return (
    <GridContainer
      data-testid="vehicledetail-card"
      container
      alignItems="stretch"
      justify="space-around"
      spacing={0}
      rowSpacing={{ xs: 2 }}
      columnSpacing={{ xs: 2 }}
      margin={0}
    >
      {vehicleOrders.length > 0 && (
        <WOStatusComponent
          availableOrderStatus={availableOrderStatus}
          setSelectedStatus={setSelectedStatus}
        />
      )}
      {vehicleOrders?.map((order, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          lg={2.4}
          key={`${order.vendorOrderId}-${index}`}
        >
          <WOTagCard
            width="100%"
            data={order}
            history={history}
            handleStartDone={handleStartDone}
            addTechnician={() => onAddTechnician(order)}
            hasActionsEnabled={enableOrderTagActions}
            isVendor={isVendor}
          />
        </Grid>
      ))}
    </GridContainer>
  );
}
